// Shimmer placeholder. Use sparingly — only for first-paint loading where the
// shape of the eventual content is well-known.

export default function Skeleton({
  className = "",
}: {
  className?: string;
}) {
  return (
    <div
      className={`animate-pulse bg-surface-2 rounded ${className}`}
      aria-hidden
    />
  );
}
